import { render, staticRenderFns } from "./post-detail.vue?vue&type=template&id=143cac4d&scoped=true&"
import script from "./post-detail.vue?vue&type=script&lang=js&"
export * from "./post-detail.vue?vue&type=script&lang=js&"
import style0 from "./post-detail.vue?vue&type=style&index=0&id=143cac4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143cac4d",
  null
  
)

export default component.exports